import type { Props } from './Svg'
import { Svg } from './Svg'

export function CheckedIcon(props: Props) {
  return (
    <Svg width="14" height="10" fill="none" {...props}>
      <path strokeWidth="2" d="m1 5 4 4 8-8" />
    </Svg>
  )
}
